<ng-container *transloco="let t; read: 'org-settings-audio-files'">
  <p-messages severity="warn">
    <ng-template pTemplate>
      <div class="ml-2">{{ t('description') }}</div>
    </ng-template>
  </p-messages>
  <app-audio-files-table-editor></app-audio-files-table-editor>
</ng-container>
